<div *ngIf="loader == true" style="height: 100vh; display: flex; justify-content: center; align-items: center;">
    <img src="../../assets/images/loading.gif" class="faLoader" width="50" height="50" />
</div>
<div class="row" style="margin: auto; padding-top: 40px;" *ngIf="loader == false" id="top">
    <div class="col-12 col-md-9 col-lg-9" >
        <div class="container"  >
            <div class="row">
                <div class="col-md-6">
                    <div class="prop_imgs_wrapper" id="imgs_wrapper" *ngIf="property_images.length > 0 ">
                        <div *ngFor="let img of property_images ; let i = index">
                            <div id="{{'img_' + i }}" style="padding-top: 40px;" data-toggle="modal" data-target="#propImgsModal" >
                                <img src="{{img.url}}" class="img-responsive prop_imgs" loading="lazy">
                            </div>
                        </div>
                    </div>
                    <div style="padding-top: 40px;" id="imgs_wrapper" *ngIf="property_images.length == 0 ">
                        <img src="https://image.shutterstock.com/image-vector/coming-soon-neon-sign-vector-600w-1114626449.jpg" class="img-responsive prop_imgs" style="width: 100%;" loading="lazy">
                    </div>
                    <div class="scroll_indicator_wrapper" *ngIf="property_images.length > 0 ">
                        <img src="../../assets/images/left-arrow.svg" (click)="scrollLeft()" class="scroll_indicator">
                        <img src="../../assets/images/right-arrow.svg" (click)="scrollRight()" class="scroll_indicator">
                    </div>
                </div>
                <div class="col-md-6" style="padding-top: 40px;">
                    <h1 style="font-weight: 600;" class="prop_name">{{ property_data.name }} </h1>        
                    <div class="d-flex justify-content-between align-items-center" >
                        <p class="prop_loc"> <fa-icon [icon]="faMapMarkerAlt" class="fa-lg" style=" color: coral" ></fa-icon>&nbsp; {{ property_data.locality }}, {{ property_data.city}}, {{ property_data.state }}</p>
                        <p class="bhk">{{property_data.totalrooms}} bhk</p>
                    </div> 
                    <hr id="prop_details">
                    <div class="prop_detail_wrapper" *ngIf="property_data.details !== '0' && property_data.details != ''">
                        <p class="prop_detail" id="prop_detail"> {{ property_data.details }} </p>
                        <p style="margin-top: 10px; color: lightseagreen;cursor: pointer;" (click)="showText()" >{{isReadMore ? 'Read more' : 'Read less'}}</p>
                    </div>
                    <div class="property_desc"> 
                        
                        <div class="prop_stay_dtl">
                            <p class="prop_stay_dtl_head">&nbsp;Rent</p>
                            <p class="prop_stay_dtl_body">&#x20B9; {{ property_data.formatted_prop_rent }} </p>
                        </div>
                
                        <div class="prop_stay_dtl">
                            <p class="prop_stay_dtl_head">&nbsp;Tenure</p>
                            <p class="prop_stay_dtl_body"> {{ property_data.tenure}} Months</p>
                        </div>
                        <div class="prop_stay_dtl">
                            <p class="prop_stay_dtl_head">&nbsp;Deposit</p>
                            <p class="prop_stay_dtl_body"> &#x20B9; {{ property_data.formatted_prop_dep}}</p>
                        </div>
                        <div class="prop_stay_dtl">
                            <p class="prop_stay_dtl_head">&nbsp;Sq.Ft.</p>
                            <p class="prop_stay_dtl_body"> {{ property_data.sqftsuper }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container" style="margin-top: 20px; padding-top: 20px; padding-bottom: 20px;" id="prop_rooms" *ngIf="rooms.length > 0">
            <div class=" prop_rooms_wrapper">
                <p class="property_amenities_head" style="margin-bottom: 20px;">Room Features</p>
                <div *ngFor="let r of rooms" class="prop_rooms" [ngStyle]="{'color' : r.status != 'occupied' ? 'black' : 'lightgray'} ">
                    <div style="display: flex; justify-content: space-between; margin-bottom: 10px;">
                        <p class="room_name"> {{ r.name }} </p>
                        <p class="room_detail">{{r.sqftsuper}} sq.ft.</p>
                    </div>
                    
                    <div style="display: flex; justify-content: space-between; margin-bottom: 20px;">
                        <p class="room_rent"> &#x20B9; {{r.formatted_room_rent }}</p>
                        <p class="room_detail" style="text-transform: capitalize;">{{r.type}}</p>
                    </div>
                    <p class="room_detail" style="text-transform: capitalize;">{{r.status}}</p>
                    <div  style="width: 100%; margin-top: 20px;">
                        <div *ngFor="let ra of r.amenities" [ngStyle]="{'display' : getIconName(ra.name) == '' ? 'none' : 'inline-block'}"  class="ramen_wrapper"  >
                            <div style="display: flex; align-items: center;">
                                <fa-icon [icon]="getIconName(ra.name)" class="fa-lg" style="margin-right: 5px;" [ngStyle]="{color: r.status != 'occupied' ?  '#007bff' : 'lightgray' }"></fa-icon>
                                <p>{{getPropAmenName(ra.name)}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container" style="margin-top: 20px; " >
            <div class="property_amenities_wrapper" *ngIf="property_data.amenities.length > 0" id="prop_amenities">
                <p class="property_amenities_head">Society Amenities</p>
                <br>
                <div style="margin: 0">
                    <div *ngFor="let propa of property_data.amenities"  style="width: fit-content; display: inline-block; margin-right: 20px;" >
                        <div class=" amenity_wrapper">
                            <div class="amenity_icon" *ngIf="propa.name != ''">
                                <fa-icon [icon]="getIconName(propa.name)" style="color: #007bff;"></fa-icon>
                            </div>
                            <p class="amenity_name">{{getPropAmenName(propa.name)}}</p>
                        </div>
                    </div>
                </div>
                
            </div>
            <div class="property_amenities_wrapper" *ngIf="property_data.amenities.length == 0" id="prop_amenities" style="padding-bottom: 20px;">
                <p class="property_amenities_head">Society Amenities</p>
                <br>
                <p>Amenities will be listed soon!</p>
                
            </div>
        </div>
        <div class="container" style="margin-top: 20px; padding-top: 20px; padding-bottom: 20px;" id="prop_rooms" *ngIf="rooms.length == 0">
            <p style="font-size: 20px; font-weight: 500;">Room details coming soon</p>
        </div>

        <div class="container" id="google_map" style="margin-top: 20px; padding-top: 20px; padding-bottom: 20px;">
            <agm-map 
                [latitude]="latitude" 
                [longitude]="longitude" 
                [zoom]="zoom" 
                style="height: 300px;">
                <agm-marker 
                    [latitude]="latitude" 
                    [longitude]="longitude">
                </agm-marker>
            </agm-map>
        </div>
        <div data-toggle="modal" data-target="#schVisitModal" class="container svisitbtn_small_screen btn-primary" style="margin-top: 20px; padding-top: 20px; padding-bottom: 20px; text-align: center;">
            <p class="bottom_sch_visit"  >Schedule Visit</p>
        </div>
        <div class="container" style="margin-top: 20px; padding-top: 20px; padding-bottom: 20px;" id="similar_props">
            <p class="property_amenities_head" style="margin-bottom: 20px;">Similar Properties</p>
            <div class="sim_props_wrapper" id="spimgs"> 
                <div *ngFor="let sp of simprops; let s = index" class="sim_props"  (click)="refresh(sp.property.id)" >
                    <div id="{{'spimg_' + s}}">
                        <img class="sim_prop_img img-responsive" *ngIf="sp.property.image != null" src="{{sp.property.image.url}}">
                        <img class="sim_prop_img_null img-responsive" *ngIf="sp.property.image == null" src="../../assets//images/coming-soon.png">
                        <div class="sim_props_detail_wrapper">
                            <p style="font-weight: 600; margin-bottom: 10px; font-size: 16px">{{sp.property.name}}</p>
                            <p style="font-weight: 500; margin-bottom: 20px; font-size: 16px;" *ngIf="sp.property.rent != 0 && sp.property.rent != null "> &#x20B9; {{sp.property.room_rent }}</p>
                            <p style="font-weight: 500; margin-bottom: 20px; font-size: 16px;" *ngIf="sp.property.rent == 0 || sp.property.rent == null ">Contact us for quote</p>
                            <p style="text-transform: capitalize;" [ngStyle]="{'color' : sp.property.status == 'partial' ? '#339af0' : sp.property.status == 'available' ? '#4BB543' : 'grey'  }">{{sp.property.status}}</p>
                            <p style="margin-top: 20px;" [ngStyle]="{'color' : sp.property.gender == 2 && sp.property.status != 'occupied'? '#F94B75' : sp.property.status != 'occupied' && sp.property.gender == 1 ? '#339af0' : sp.property.status == 'occupied' ? 'gray' : 'lightseagreen' }">{{sp.property.gender == 2 ? 'Girls' : sp.property.gender == 1 ? 'Boys' : 'Family'  }}</p>                        
                        </div>
                    </div>
                </div>
            </div>
            <div class="scroll_indicator_wrapper" *ngIf="simprops.length > 0 ">
                <img src="../../assets/images/left-arrow.svg" (click)="scrollLeftSimProps()" class="scroll_indicator">
                <img src="../../assets/images/right-arrow.svg" (click)="scrollRightSimProps()" class="scroll_indicator">
            </div>
        </div>
 
    </div>
    <div class="col-md-3 schedulevisit" style="width: 100%;" id="schedule_visit">
        <div  style=" box-shadow: 0 1px 6px rgba(32, 33, 36, 0.28); padding-top: 20px; padding-bottom: 20px;" class="schedule_visit">
            <div  >
                <div style="padding-bottom: 10px; border-bottom: 1px solid #efeeee; margin-bottom: 20px; text-align: center;" id="svisit_head">
                    <p class="property_amenities_head" >Schedule Visit </p>
                </div>
                <form role="form">
                    <div class="form-group ">
                        <input type="text" placeholder="Name" class="form-control" style="width: 100%;" name="name" [ngModel]="scheduleVisit.name" (ngModelChange)="onTenName($event)">
                    </div>
                    <div class="form-group ">
                        <input type="text" placeholder="Email" class="form-control" style="width: 100%;" name="email" [ngModel]="scheduleVisit.email" (ngModelChange)="onTenEmail($event)">
                    </div>
                    <div class="form-group ">
                        <input type="text" placeholder="Phone" maxlength="10" class="form-control" style="width: 100%;" name="phone" [ngModel]="scheduleVisit.phone" (ngModelChange)="onTenPhone($event)">
                    </div>
                    <div class="form-group ">
                        <input type="date" placeholder="Date" class="form-control" style="width: 100%;" [min]="minSchVisDate" name="date" [ngModel]="scheduleVisit.visitdate" (ngModelChange)="onTenVisDate($event)">
                    </div>
                    <div class="form-group ">
                        <input type="datetime" placeholder="HH:MM*" class="form-control" style="width: 100%;" name="datetime" [ngModel]="scheduleVisit.visittime" (ngModelChange)="onTenVisTime($event)">
                    </div>
                    
                    <div class="form-group " >
                        <p class="btn-primary visitBtn" (click)="submitSchlVisit()"> Submit </p>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="propImgsModal" tabindex="-1" aria-labelledby="propImgsLabel" aria-hidden="true" style="padding: 0px 20px;">
    <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <div class="modal-body">
                    <div style="width: 100%; display: flex; justify-content: space-between; ">
                        <p class="prop_name">Property Images</p>
                        <fa-icon [icon]="faTimes" class="fa-sm" data-dismiss="modal" ></fa-icon>
                    </div>
                    
                    <div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
                        <div class="carousel-inner">
                            <div *ngFor="let imgs of property_big_images ; let i = index" class="carousel-item" [ngClass]="i == 0 ? 'active' : ''">
                                <div id="{{'imgs_' + i }}" style="padding-top: 40px;" >
                                    <img src="{{imgs.url}}" class="d-block w-100" loading="lazy">
                                </div>
                            </div>
                        </div>
                        <div class="scroll_indicator_wrapper" *ngIf="property_images.length > 0 ">
                            <a  class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
                                <img  aria-hidden="true" src="../../assets/images/left-arrow.svg"  class="scroll_indicator">
                            </a>
                            
                            <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
                                <img aria-hidden="true" src="../../assets/images/right-arrow.svg"  class="scroll_indicator">
                            </a>
                        </div>
                      </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="schVisitModal" tabindex="-1" aria-labelledby="schVisitModalLabel" aria-hidden="true" style="padding: 0px 20px;">
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <div class="modal-body">
                    <div style="width: 100%; display: flex; justify-content: end; position: absolute; top:-10px; right: -5px; cursor: pointer;">
                        <fa-icon [icon]="faTimes" class="fa-sm" data-dismiss="modal" ></fa-icon>
                    </div>
                    <div style="padding-bottom: 10px; border-bottom: 1px solid #efeeee; margin-bottom: 20px; text-align: center;" id="svisit_head">
                        <p class="property_amenities_head" >Schedule Visit </p>
                    </div>
                    <form role="form">
                        <div class="form-group ">
                            <input type="text" placeholder="Name *" class="form-control" style="width: 100%;" name="name" [ngModel]="scheduleVisit.name" (ngModelChange)="onTenName($event)">
                        </div>
                        <div class="form-group ">
                            <input type="text" placeholder="Email *" class="form-control" style="width: 100%;" name="email" [ngModel]="scheduleVisit.email" (ngModelChange)="onTenEmail($event)">
                        </div>
                        <div class="form-group ">
                            <input type="text" placeholder="Phone *" maxlength="10" class="form-control" style="width: 100%;" name="phone" [ngModel]="scheduleVisit.phone" (ngModelChange)="onTenPhone($event)">
                        </div>
                        <div class="form-group ">
                            <input type="date" placeholder="Date *" class="form-control" style="width: 100%;" [min]="minSchVisDate" name="date" [ngModel]="scheduleVisit.visitdate" (ngModelChange)="onTenVisDate($event)">
                        </div>
                        <div class="form-group ">
                            <input type="datetime" placeholder="Time (HH:MM)*" class="form-control" style="width: 100%;" name="datetime" [ngModel]="scheduleVisit.visittime" (ngModelChange)="onTenVisTime($event)">
                        </div>
                        
                        <div class="visit_submit_msg" *ngIf="submit_schl == true">
                            <p> {{ schl_msg }} </p>
                        </div>
                        <div class="visit_success_msg" *ngIf="schl_success == true">
                            <p> {{ schl_msg }} </p>
                        </div>
                        <div class="form-group " >
                            <p class="btn-primary visitBtn" (click)="submitSchlVisit()"> Submit </p>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
 
    
</div>

<div class="visit_submit_msg" *ngIf="submit_schl == true">
    <p> {{ schl_msg }} </p>
</div>
<div class="visit_success_msg" *ngIf="schl_success == true">
    <p> {{ schl_msg }} </p>
</div>